import React from 'react';
import {FormattedMessage} from 'react-intl';
import messages from '../../../res/translations/messages';
import InstanceFilterButton from './InstanceFilterButton';
import {INSTANCE_FILTERS} from '../../constants';

const InstanceFilters = ({value, onChange}) => (
    <div className="btn-group" style={{height: '2.2rem'}}>
        <InstanceFilterButton active={value === INSTANCE_FILTERS.COMPLETED} value={INSTANCE_FILTERS.COMPLETED} onClick={onChange}>
            <FormattedMessage {...messages.dashboard.filters.completed} />
        </InstanceFilterButton>
        <InstanceFilterButton active={value === INSTANCE_FILTERS.ALL} value={INSTANCE_FILTERS.ALL} onClick={onChange}>
            <FormattedMessage {...messages.dashboard.filters.all} />
        </InstanceFilterButton>
        <InstanceFilterButton active={value === INSTANCE_FILTERS.NOT_COMPLETED} value={INSTANCE_FILTERS.NOT_COMPLETED} onClick={onChange}
            style={{width: '120px'}}>
            <FormattedMessage {...messages.dashboard.filters.notCompleted} />
        </InstanceFilterButton>
    </div>
);

export default InstanceFilters;
